export default __webpack_public_path__ + "static/media/award2012.c43d00d3.png";